// API URL: Use REACT_APP_API_URL if set (for E2E tests), otherwise use defaults
export const BASE_URL = process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'development' ? 'http://localhost:5000' : '');

export const STUDY_ABBREVIATION_MAP = {
  'shoulder arthroscopy': 'SAs',
  'shoulder arthroplasty': 'SAp',
  'elbow': 'Elbow ',
};

export const studyCamelCaseToSpacedCapitalizedMap = {
  'elbow': 'Elbow',
  'shoulderArthroplasty' : 'Shoulder Arthroplasty',
  'shoulderArthroscopy': 'Shoulder Arthroscopy',
};

export const studySpacedCapitalizedToCamelCaseMap = {
  'Elbow': 'elbow',
  'Shoulder Arthroplasty': 'shoulderArthroplasty',
  'Shoulder Arthroscopy': 'shoulderArthroscopy',
};

// React-select configuration to ensure dropdowns appear above accordion content
export const reactSelectStyles = {
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  menu: (base) => ({ ...base, zIndex: 9999 }),
  placeholder: (base) => ({
    ...base,
    fontStyle: 'italic',
    color: 'var(--color-neutral-500)',
  }),
};
